import { add } from 'date-fns';
import { preciseDifference, prettyPrintPreciseDiff, prettyPrintPreciseDiffToSeconds } from './preciseDiff';

export function prettyPrintMinutes(minutes: number): string {
  const rightDate = new Date();
  const leftDate = add(rightDate, { minutes });
  const preciseDiff = preciseDifference(leftDate, rightDate);
  return prettyPrintPreciseDiff(preciseDiff);
}

export function prettyPrintMinutesSingleUnit(minutes: number): string {
  const rightDate = new Date();
  const leftDate = add(rightDate, { minutes });
  const preciseDiff = preciseDifference(leftDate, rightDate);
  return prettyPrintPreciseDiff(preciseDiff, 1);
}

export function prettyPrintSeconds(seconds: number): string {
  const rightDate = new Date();
  const leftDate = add(rightDate, { seconds });
  const preciseDiff = preciseDifference(leftDate, rightDate, ['month', 'day', 'hour', 'minute', 'second']);
  return prettyPrintPreciseDiffToSeconds(preciseDiff);
}
